import React from 'react';
import './styles.scss';

const isDev = process.env.NODE_ENV === 'development';

const Section = (props) => {
  const { className, containerClassName, id, children, sliceName, noContainer } = props;
  return (
    <section className={`section ${className || ''}`} id={id || ''} data-slice={isDev ? sliceName : null}>
      {noContainer ? children : <div className={`container ${containerClassName || ''}`}>{children}</div>}
    </section>
  );
};

export default Section;
